var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"bottom":"","rounded":"pill","content-class":_vm.snackbarClass},model:{value:(_vm.alerta),callback:function ($$v) {_vm.alerta=$$v},expression:"alerta"}},[_vm._v(" "+_vm._s(_vm.textAlert)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }